import { render } from "./StarRightSide.vue?vue&type=template&id=79a02e4d"
import script from "./StarRightSide.vue?vue&type=script&lang=js"
export * from "./StarRightSide.vue?vue&type=script&lang=js"

import "./StarRightSide.vue?vue&type=style&index=0&id=79a02e4d&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__